export const PATH = {
    ROOT: '/',
    DASHBOARD: '/Dashboard',
    UPDATES: '/Updates',
    MY_PRODUCTS: '/MyProducts',
    PRODUCT_DETAIL: '/MyProducts/:connectorId',
    PRODUCT_MAPPINGS: '/MyProducts/:connectorId/mappings',
    PRODUCT_ATTRIBUTE_MAPPINGS: '/MyProducts/:connectorId/attribute-mappings',
    VIEW_SUMMARY: '/ViewSummary/:connectorId',
    SUMMARY_DETAILS: '/SummaryDetails/:connectorId',
    SETUP: '/Setup/:connectorId/:instanceId',
    CONFIGURATIONS: '/configurations/:connectorId/:instanceId',
    AUTHENTICATION: '/Authentication/:connectorId/:instanceId',
    MARKETPLACE: '/Marketplace',
    USERS: '/Users',
    NEW_CONNECTOR: '/createconnector',
    EGE: '/Ege',
    EGE_SETUP_DOWNLOAD: '/Egesetupdownload',
    TRIAL_CONNECTOR: '/connector/:id/:name',
    TRIAL_SUBSCRIPTION: '/subscription'
}

// Full-page workspaces that bring their own layout and hide the app header and sidebar.
export const FULL_PAGE_PATHS = [PATH.PRODUCT_MAPPINGS, PATH.PRODUCT_ATTRIBUTE_MAPPINGS]

export const LEGACY_PATH = {
    VIEW_SUMMARY: '/ViewSummary',
    SUMMARY_DETAILS: '/SummaryDetails',
    SETUP: '/Setup',
    CONFIGURATIONS: '/configurations',
    AUTHENTICATION: '/Authentication'
}

const withQuery = (pathname, params) => {
    const search = new URLSearchParams()
    Object.keys(params || {}).forEach((key) => {
        const value = params[key]
        if (value !== undefined && value !== null && value !== '') {
            search.set(key, value)
        }
    })
    const query = search.toString()
    return query ? `${pathname}?${query}` : pathname
}

export const paths = {
    newConnector: ({ system, integration, from, step } = {}) => withQuery('/createconnector', { system, integration, from, step }),
    myProducts: (options = {}) => withQuery('/MyProducts', { status: options.status }),
    productDetail: (connectorId) => `/MyProducts/${connectorId}`,
    productMappings: (connectorId) => `/MyProducts/${connectorId}/mappings`,
    productAttributeMappings: (connectorId) => `/MyProducts/${connectorId}/attribute-mappings`,
    setup: (connectorId, instanceId) => `/Setup/${connectorId}/${instanceId}`,
    configurations: (connectorId, instanceId) => `/configurations/${connectorId}/${instanceId}`,
    authentication: (connectorId, instanceId) => `/Authentication/${connectorId}/${instanceId}`,
    viewSummary: (connectorId, options = {}) => withQuery (`/ViewSummary/${connectorId}`, {
        direction: options.direction === 'target' ? 'target' : undefined,
        preset: options.preset,
        from: options.from,
        to: options.to
    }),

    summaryDetails: (connectorId, options) => withQuery(`/SummaryDetails/${connectorId}`, options),
    trialConnector: (id, name) => `/connector/${id}/${encodeURIComponent(name)}`
}
